import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import Checkbox from '../atoms/checkbox';

const Container = styled.div``;

const AnswerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

class LicenceSelectorCheckbox extends React.Component {

  render() {
    const { answer, userAnswers, setAnswer } = this.props;
    const isSelected = userAnswers[answer.criteria] === answer.value;

    return (
      <Container>
        <AnswerContainer key={answer.key}>
          <Checkbox
            checked={!!isSelected}
            onChange={() => {
              const isSelected = userAnswers[answer.criteria] === answer.value;
              if (isSelected) {
                setAnswer(answer.criteria, null);
              } else {
                setAnswer(answer.criteria, answer.value);
              }
             }}
            label={I10n.getOrDefault(`screen.licence_selector.modal.answer.name.${answer.labelKey}`, answer.name)}
          />
        </AnswerContainer>
      </Container>
    );
  }
}

export default LicenceSelectorCheckbox;
